let isRefreshing = false;
let refreshSubscribers = [];

export const addSubscriber = (callback) => {
  refreshSubscribers.push(callback);
};

export const notifySubscribers = (newToken) => {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
};

export const getIsRefreshing = () => isRefreshing;
export const setIsRefreshing = (value) => {
  isRefreshing = value;
};